import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Login from './Pages/Login/Login';
import Main from './Pages/Main/Main';
import AdminDashboard from './Pages/Admin/Dashboard';
import UserDashboard from './Pages/User/Dashboard';
import PrivateRoute from './Auth/PrivateRoute';
import Vetrina from './Pages/Vetrina/Vetrina';


// Componente wrapper per gestire il prompt PWA
const PWAPromptHandler = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      // Permetti il prompt solo per '/', '/login', e '/admin'
      if (
        location.pathname === '/' ||
        location.pathname === '/login' ||
        location.pathname === '/admin'
      ) {
        // Permetti il prompt di default
        return true;
      } else {
        // Blocca il prompt per tutte le altre route (es. /:clientSubdomain)
        e.preventDefault();
      }
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, [location]);

  return children;
};

function App() {
  return (
    
      <Router>
        <PWAPromptHandler>
          <div className="App">
            <Routes>
              {/* La Vetrina è la pagina pubblica di default */}
              <Route path="/" element={<PrivateRoute element={<AdminDashboard />} />} />
              <Route path="/vetrina" element={<Vetrina />} />
              
              {/* Route per i subdomain */}
              <Route path="/:clientSubdomain" element={<Main />} />
              
              {/* Altre route */}
              <Route path="/login" element={<Login />} />
              
              {/* Route protette */}
              <Route 
                path="/admin" 
                element={<PrivateRoute element={<AdminDashboard />} />} 
              />
              <Route 
                path="/user" 
                element={<PrivateRoute element={<UserDashboard />} />} 
              />
            </Routes>
          </div>
        </PWAPromptHandler>
      </Router>
   
  );
}

export default App;